/* pn-generic.js — logique produit Memo WW (genere par build_pn.py, source: pn-generic.liquid) */
(function () {
  function initOne(cfgEl) {
    if (cfgEl.dataset.pnDone) return; cfgEl.dataset.pnDone = '1';
    var CFG; try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var section = cfgEl.closest('.shopify-section') || document.getElementById('shopify-section-' + CFG.sid);
    if (!section) return;
var mq = window.matchMedia('(max-width: 999px)');
    var PN_TPL = CFG.tpl; /* suffixe du template rendu ('' = product.json par defaut) */
    var PN_HANDLE = CFG.handle;
    var PN_OPEN_FIRST_ACC = CFG.openAcc;
    var MOVE_TOP = [
      '.product-info__block-item[data-block-type="product-title"]',
      '.product-info__block-item[data-block-type="@app"][data-block-id*="judge_me"]'
    ];
    var TRY_IT = '.product-info__block-item.pn-tryit';
    var DESC = '.product-info__block-list > .product-info__block-group'; /* mobile : le try-it se place avant le groupe d'accordeons (Inspiration/Notes/Ingredients) */

    function canonical(sel) {
      var els = Array.prototype.slice.call(section.querySelectorAll(sel));
      if (!els.length) return null;
      var inInfo = els.filter(function (el) { return el.closest('.product-info'); });
      var keep = inInfo.length ? inInfo[0] : els[0];
      els.forEach(function (el) { if (el !== keep) el.remove(); });
      return keep;
    }

    function mark(el) {
      var id = el.getAttribute('data-block-id');
      if (section.querySelector('[data-pn-ph="' + id + '"]')) return;
      var ph = document.createElement('span');
      ph.hidden = true;
      ph.setAttribute('data-pn-ph', id);
      el.parentNode.insertBefore(ph, el);
    }

    function restore(el) {
      var id = el.getAttribute('data-block-id');
      var ph = section.querySelector('[data-pn-ph="' + id + '"]');
      if (ph) { ph.parentNode.insertBefore(el, ph); ph.remove(); }
    }

    function ensureHeader() {
      var gal = section.querySelector('.product-gallery');
      if (!gal) return null;
      var h = gal.querySelector(':scope > .pn-mobile-header');
      if (!h) {
        h = document.createElement('div');
        h.className = 'pn-mobile-header product-info__block-list';
        gal.insertBefore(h, gal.firstChild);
      }
      return h;
    }

    // met a jour miniatures + visibilite des fleches (masquees en bout de galerie)
    function setGalCurrent(idx) {
      var sc = section.querySelector('.product-gallery scroll-carousel');
      if (!sc) return;
      var count = sc.querySelectorAll('.product-gallery__media:not([hidden])').length;
      var tw = section.querySelector('.pn-thumbs');
      if (tw) {
        Array.prototype.forEach.call(tw.children, function (c, j) {
          c.classList.toggle('is-current', j === idx);
        });
      }
      var prev = section.querySelector('.pn-gal-arrow--prev');
      var next = section.querySelector('.pn-gal-arrow--next');
      if (prev) prev.style.display = idx <= 0 ? 'none' : '';
      if (next) next.style.display = idx >= count - 1 ? 'none' : '';
    }

    function ensureArrows() {
      var sc = section.querySelector('.product-gallery scroll-carousel');
      if (!sc) return;
      var medias = sc.querySelectorAll('.product-gallery__media:not([hidden])');
      var host = sc.parentElement;
      /* visuels EMPILES verticalement (desktop fuslap etc.) : le carrousel ne defile pas horizontalement -> AUCUNE fleche */
      var scrollable = sc.scrollWidth > sc.clientWidth + 10;
      if (!scrollable || medias.length < 2) {
        if (host) host.querySelectorAll('.pn-gal-arrow').forEach(function (b) { b.remove(); });
        return;
      }
      if (!host || host.querySelector('.pn-gal-arrow')) return;
      [
        ['prev', -1, 'M10 2 4 8l6 6'],
        ['next', 1, 'M6 2l6 6-6 6']
      ].forEach(function (cfg) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pn-gal-arrow pn-gal-arrow--' + cfg[0];
        b.setAttribute('aria-label', cfg[0] === 'prev' ? 'Previous image' : 'Next image');
        b.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="' + cfg[2] + '" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        b.addEventListener('click', function () {
          var w = sc.clientWidth;
          var medias = sc.querySelectorAll('.product-gallery__media:not([hidden])');
          var count = medias.length;
          if (!count) return;
          var target = Math.max(0, Math.min(count - 1, Math.round(sc.scrollLeft / w) + cfg[1]));
          sc.scrollTo({ left: medias[target].offsetLeft, behavior: 'smooth' });
          setGalCurrent(target);
        });
        host.appendChild(b);
      });
      setGalCurrent(Math.round(sc.scrollLeft / (sc.clientWidth || 1)));
    }

    function ensureThumbs() {
      var sc = section.querySelector('.product-gallery scroll-carousel');
      if (!sc) return;
      var medias = Array.prototype.slice.call(sc.querySelectorAll('.product-gallery__media:not([hidden])'));
      if (medias.length < 2) return;
      var gal = section.querySelector('.product-gallery');
      var dots = gal.querySelector('.page-dots');
      var wrap = gal.querySelector('.pn-thumbs');
      if (wrap && wrap.children.length === medias.length) return;
      if (wrap) wrap.remove();
      wrap = document.createElement('div');
      wrap.className = 'pn-thumbs';
      medias.forEach(function (m, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pn-thumb' + (i === 0 ? ' is-current' : '');
        b.setAttribute('aria-label', 'Image ' + (i + 1));
        var img = m.querySelector('img');
        var vid = m.querySelector('video');
        var src = img ? (img.currentSrc || img.src) : (vid && vid.getAttribute('poster') ? vid.getAttribute('poster') : null);
        if (src) {
          /* MEMO PERF 2026-08-24 : la vignette recopiait le src PLEINE TAILLE de la galerie
             (width=1280 pour les photos, 900 pour le poster video) dans une boite mesuree a
             46 px de cote, soit ~850 Ko gaspilles par fiche produit. On demande au CDN Shopify
             une largeur proportionnee. La vignette est dimensionnee par la CSS et non par la
             taille intrinseque : la mise en page est inchangee, et 200 px couvre 46 px
             jusqu'a un DPR de 4,3, donc la nettete l'est aussi. */
          var tsrc = src;
          if (/(\/cdn\/shop\/|cdn\.shopify\.com)/.test(tsrc)) {
            if (/[?&]width=\d+/.test(tsrc)) {
              tsrc = tsrc.replace(/([?&])width=\d+/, '$1width=200');
            } else {
              tsrc += (tsrc.indexOf('?') > -1 ? '&' : '?') + 'width=200';
            }
          }
          var t = document.createElement('img');
          t.src = tsrc; t.alt = ''; t.loading = 'lazy';
          b.appendChild(t);
        }
        var mtype = m.getAttribute('data-media-type') || '';
        if (mtype.indexOf('video') > -1 || vid) {
          var play = document.createElement('span');
          play.className = 'pn-thumb__play';
          play.innerHTML = '<span><svg viewBox="0 0 10 12" aria-hidden="true"><path d="M0 0l10 6-10 6z" fill="currentColor"/></svg></span>';
          b.appendChild(play);
        }
        b.addEventListener('click', function () {
          sc.scrollTo({ left: m.offsetLeft, behavior: 'smooth' });
          setGalCurrent(i);
        });
        wrap.appendChild(b);
      });
      if (dots) { dots.parentNode.insertBefore(wrap, dots); } else { gal.appendChild(wrap); }
      if (!sc.pnThumbSync) {
        sc.pnThumbSync = true;
        sc.addEventListener('scroll', function () {
          clearTimeout(sc.pnThumbT);
          sc.pnThumbT = setTimeout(function () {
            setGalCurrent(Math.round(sc.scrollLeft / sc.clientWidth));
          }, 80);
        }, { passive: true });
      }
    }

    function applyTitleSizes(mobile) {
      var sel = '.h2.tw-text-4xl, .shopify-section[id*="xm_gallery"] h2, .jdgm-rev-widg__title';
      document.querySelectorAll(sel).forEach(function (el) {
        if (mobile) { el.style.setProperty('font-size', '35px', 'important'); }
        else { el.style.removeProperty('font-size'); }
      });
    }

    /* pose des classes STABLES (independantes des IDs de bloc, qui varient d'un template a l'autre) :
       .pn-tryit sur le bloc "try it before you decide", .pn-acc-notes / .pn-acc-ing sur les accordeons
       dont le titre est Notes / Ingredients (FR: Notes / Ingrédients). */
    function pnTag() {
      var tryItText = section.querySelector('.product-info .try-it-first-text');
      if (tryItText) {
        var item = tryItText.closest('.product-info__block-item');
        if (item) item.classList.add('pn-tryit');
      }
      section.querySelectorAll('.product-info .product-info__block-item[data-block-type="accordion"]').forEach(function (item) {
        var toggle = item.querySelector('.accordion__toggle, summary');
        if (!toggle) return;
        var t = toggle.textContent.trim().toLowerCase();
        if (/^notes/.test(t)) item.classList.add('pn-acc-notes');
        else if (/^ingr[ée]dient/.test(t)) item.classList.add('pn-acc-ing');
      });
    }

    function apply() {
      var mobile = mq.matches;
      pnTag();
      applyTitleSizes(mobile);
      var header = ensureHeader();
      MOVE_TOP.forEach(function (sel) {
        var el = canonical(sel);
        if (!el) return;
        if (mobile && header && !header.contains(el)) {
          mark(el);
          header.appendChild(el);
        } else if (!mobile) {
          if (sel.indexOf('judge_me') > -1) {
            /* desktop : avis sous le type produit, avant la ligne du bloc titre */
            var t = section.querySelector('.product-info [data-block-type="product-title"]');
            var hrT = t ? t.querySelector(':scope > hr') : null;
            if (t && hrT) {
              if (el.nextElementSibling !== hrT || el.parentElement !== t) { mark(el); t.insertBefore(el, hrT); }
            } else if (!el.closest('.product-info')) {
              restore(el);
            }
          } else if (!el.closest('.product-info')) {
            restore(el);
          }
        }
      });
      /* badge avis dans le header mobile : neutraliser les marges heritees des styles de template
         (US : une regle a ID mettait margin-bottom 30px -> +30 sous les reviews) — inline = imbattable */
      if (mobile && header) {
        var pnBdg = header.querySelector('.jdgm-prev-badge');
        if (pnBdg) { pnBdg.style.setProperty('margin-bottom', '0', 'important'); pnBdg.style.setProperty('margin-top', '12px', 'important'); }
      }
      /* le bloc try-it reste a sa place du template (sous INGREDIENTS), comme sur desktop */
      ensureArrows();
      ensureThumbs();
      ensureTopLine();
      ensureContentLast();
      ensureEngraving();
      skinCloudlift();
      ensureAdvArrows();
      ensureShipping();
      ensureNoAtcLine();
      ensureAtcSpacing();
    }

    /* ligne du haut du header mobile : injectee si le bloc titre n'a pas son propre separateur (fuslap, filage) */
    function ensureTopLine() {
      var header = section.querySelector('.pn-mobile-header');
      if (!header) return;
      var titleBlock = header.querySelector('[data-block-type="product-title"]');
      if (!titleBlock) return;
      var hasHr = titleBlock.querySelector(':scope > hr:not(.pn-top-line)'); /* EXCLURE ma propre ligne, sinon oscillation infinie (page qui saute) */
      var mine = header.querySelector('.pn-top-line');
      if (!mq.matches || hasHr) { if (mine) mine.remove(); return; }
      if (mine) return;
      var hr = document.createElement('hr');
      hr.className = 'pn-top-line';
      hr.setAttribute('aria-hidden', 'true');
      titleBlock.insertBefore(hr, titleBlock.firstChild);
    }

    /* ENGRAVING + VOUCHER : 1er volet (Inspiration) ouvert et sans titre ("le volet doit etre directement ouvert") */
    function ensureEngraving() {
      if (!PN_OPEN_FIRST_ACC) return;
      var group = section.querySelector('.product-info .product-info__block-group');
      if (!group) return;
      var first = group.querySelector('.product-info__block-item[data-block-type="accordion"]');
      if (!first) return;
      first.classList.add('pn-eng-open');
      var det = first.querySelector('details');
      if (det && !det.open) det.open = true;
    }

    /* product.json par defaut : le(s) bloc(s) "contenu" doivent passer A LA FIN (apres les accordeons) */
    function ensureContentLast() {
      if (PN_TPL) return; /* uniquement product.json par defaut (suffixe vide/nil -> '' ou null) */
      var list = section.querySelector('.product-info .product-info__block-list');
      if (!list) return;
      var contents = Array.prototype.slice.call(list.querySelectorAll(':scope > .product-info__block-item[data-block-type="content"]'));
      if (!contents.length) return;
      function skipReal(el) {
        return el.classList.contains('pn-ship') || el.classList.contains('pn-ship-line') ||
          el.classList.contains('pn-ship-after') || el.getAttribute('data-block-type') === 'liquid' ||
          el.getAttribute('data-block-type') === 'complementary-products' ||
          getComputedStyle(el).display === 'none'; /* pas de filtre hauteur : l'ancre (accordeons) doit rester stable meme a 0px au chargement */
      }
      /* ancre = dernier bloc "reel" qui n'est PAS un contenu ni un widget shipping (ex. groupe d'accordeons) */
      var reals = Array.prototype.filter.call(list.children, function (el) {
        return contents.indexOf(el) < 0 && !skipReal(el);
      });
      if (!reals.length) return;
      var anchor = reals[reals.length - 1];
      /* deplacer chaque bloc contenu juste apres l'ancre, en conservant l'ordre (idempotent) */
      contents.forEach(function (c) {
        if (c.previousElementSibling === anchor) { anchor = c; return; }
        anchor.parentNode.insertBefore(c, anchor.nextSibling);
        anchor = c;
      });
    }

    /* pas de selecteur de variante (ex. discovery-set) : l'ATC herite d'une grosse marge haute (32px) -> reduire */
    function ensureAtcSpacing() {
      /* pas de variante VISIBLE + ATC visible (ex. body lotion) -> classe pn-no-variant (ligne des reviews
         masquee + ATC rapproche). Exclut engraving/voucher (ATC masque : leur ligne sert au texte marketing). */
      var vp = section.querySelector('.product-info [data-block-type="variant-picker"]');
      var vpVisible = !!(vp && vp.getBoundingClientRect().height > 2);
      /* on teste TOUS les boutons du bloc : quand le formulaire << Notify me >> (rupture de stock)
         s'ouvre, le bouton declencheur passe en hidden et c'est son bouton d'envoi qui devient
         visible. Ne regarder que le PREMIER faisait basculer la section de .pn-no-variant a
         .pn-no-atc au clic -> saut vertical de toute la colonne produit. */
      var atcVisible = Array.prototype.some.call(
        section.querySelectorAll('.product-info [data-block-type="buy-buttons"] button'),
        function (b) { return b.offsetParent !== null; });
      section.classList.toggle('pn-no-variant', !vpVisible && atcVisible);
      if (vp) return;
      var bb = section.querySelector('.product-info__block-item[data-block-type="buy-buttons"]');
      /* discovery : l'ATC ne doit pas coller au badge reviews -> 26px ; ailleurs 10px */
      if (bb) bb.style.setProperty('margin-block-start', PN_TPL === 'discovery-set' ? '26px' : '10px', 'important');
    }

    /* si le produit n'a PAS de bouton Ajouter au panier (bloc hide_atc actif) : ligne sous le selecteur de variante */
    function ensureNoAtcLine() {
      /* bloc "avantages" VIDE (ex. samples) : ses marges creent une 2e ligne fantome -> masque.
         ⚠️ le swiper est TELEPORTE en differe : tester les slides (pas scrollHeight, qui reste 0 une fois masque)
         et ne masquer qu'apres 4s sans slide ; re-afficher des qu'un slide apparait */
      var adv = section.querySelector('.product-info [data-block-type="advantage-swiper"]');
      if (adv) {
        if (adv.querySelector('.swiper-slide')) { adv.style.display = ''; }
        else if (!adv.pnT) { adv.pnT = setTimeout(function () { if (!adv.querySelector('.swiper-slide')) adv.style.display = 'none'; }, 4000); }
      }
      var vp = section.querySelector('.product-info__block-item[data-block-type="variant-picker"]');
      if (!vp) return;
      /* idem : n'importe quel bouton visible du bloc d'achat compte (cf. formulaire << Notify me >>) */
      var atcVisible = Array.prototype.some.call(
        section.querySelectorAll('.product-info [data-block-type="buy-buttons"] button, .product-info .product-form__buttons button, .product-info button[name="add"]'),
        function (b) { return b.offsetParent !== null; });
      var line = section.querySelector('.pn-noatc-line');
      if (!atcVisible) {
        section.classList.add('pn-no-atc');
        if (!line) {
          line = document.createElement('hr');
          line.className = 'pn-noatc-line';
          line.setAttribute('aria-hidden', 'true');
          vp.parentNode.insertBefore(line, vp.nextSibling);
        }
        /* si le bloc visible suivant est un accordeon (qui a deja sa propre ligne), ma ligne fait doublon -> masquee */
        var nx = line.nextElementSibling;
        while (nx && (getComputedStyle(nx).display === 'none' || nx.getBoundingClientRect().height < 2)) nx = nx.nextElementSibling;
        var redundant = nx && (nx.classList.contains('product-info__block-group') || nx.getAttribute('data-block-type') === 'accordion');
        line.style.display = redundant ? 'none' : '';
      } else {
        section.classList.remove('pn-no-atc');
        if (line) line.remove();
      }
    }

    /* ====== estimation de livraison (regles des delivery profiles Shopify WW) ====== */
    var PN_SHIP = { country: CFG.ship.country, countryName: CFG.ship.countryName, currency: CFG.ship.currency, price: CFG.ship.price / 100, requiresShipping: CFG.ship.requiresShipping, isVoucher: CFG.ship.isVoucher, url: CFG.ship.url };
    /* zones -> [delai min, delai max] jours + gratuite [montant, devise] */
    /* delais et transporteur = offre STANDARD de chaque zone (jamais l'option express) */
    var PN_ZONES = [
      { c: 'US', d: [2, 5], free: [150, 'USD'], via: 'USPS' },
      { c: 'CA', d: [3, 10], free: [200, 'USD'], via: 'Standard Shipping' }
    ];
    var PN_ZONE_ROW = null; /* US ne livre que US+CA : pays hors zones -> pas de widget */
    /* jours feries US (federaux observes) 2026-2027 */
    var PN_HOLIDAYS = ['2026-01-01','2026-01-19','2026-02-16','2026-05-25','2026-06-19','2026-07-03','2026-09-07','2026-10-12','2026-11-11','2026-11-26','2026-12-25','2027-01-01','2027-01-18','2027-02-15','2027-05-31','2027-06-18','2027-07-05','2027-09-06','2027-10-11','2027-11-11','2027-11-25','2027-12-24','2027-12-31'];

    function pnIsoLocal(d) {
      return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
    }
    function pnIsClosed(d) { /* week-end ou ferie francais : pas d'expedition */
      var dow = d.getDay();
      return dow === 0 || dow === 6 || PN_HOLIDAYS.indexOf(pnIsoLocal(d)) > -1;
    }
    function pnEstimate(minDays, extraProd) {
      /* expedition : 1er jour ouvre a partir de demain (preparation) ; commande apres 14h (heure de New York) -> +1 jour ouvre */
      var ship = new Date();
      do { ship.setDate(ship.getDate() + 1); } while (pnIsClosed(ship));
      var parisHour = 14;
      try { parisHour = parseInt(new Date().toLocaleString('en-GB', { timeZone: 'America/New_York', hour: '2-digit', hour12: false }), 10); } catch (e) {}
      if (parisHour >= 14) {
        do { ship.setDate(ship.getDate() + 1); } while (pnIsClosed(ship));
      }
      /* gravure : +N jours ouvres de production avant expedition */
      for (var p = 0; p < (extraProd || 0); p++) {
        do { ship.setDate(ship.getDate() + 1); } while (pnIsClosed(ship));
      }
      /* transit : minDays jours, en sautant dimanches et feries US (livraison possible le samedi) */
      var d = new Date(ship), added = 0;
      while (added < minDays) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && PN_HOLIDAYS.indexOf(pnIsoLocal(d)) === -1) added++;
      }
      /* securite : JAMAIS une livraison un dimanche (ni un ferie) -> repousser au jour suivant */
      while (d.getDay() === 0 || PN_HOLIDAYS.indexOf(pnIsoLocal(d)) > -1) {
        d.setDate(d.getDate() + 1);
      }
      return d;
    }
    function pnZone() {
      for (var i = 0; i < PN_ZONES.length; i++) {
        if ((',' + PN_ZONES[i].c + ',').indexOf(',' + PN_SHIP.country + ',') > -1) return PN_ZONES[i];
      }
      return PN_ZONE_ROW;
    }
    function pnMoney(amount, cur) {
      if (cur === 'EUR') return amount + '€';
      if (cur === 'GBP') return '£' + amount;
      if (cur === 'USD') return '$' + amount;
      return amount.toLocaleString(PN_FR ? 'fr-FR' : 'en-GB') + ' ' + cur;
    }
    function pnEngravingOn() {
      /* gravure cochee : checkbox Cloudlift OU custom element natif */
      var clb = section.querySelector('.cl-po--option[data-option="Engraving"] input[type="checkbox"]');
      if (clb) return clb.checked;
      var nat = section.querySelector('engraving-option input[type="checkbox"], .engraving__toggle input[type="checkbox"]');
      return nat ? nat.checked : false;
    }
    function renderShip(el) {
      var zone = pnZone();
      if (!zone) return;
      var date = pnEstimate(zone.d[0], pnEngravingOn() ? 2 : 0);
      var dateTxt = date.toLocaleDateString(PN_FR ? 'fr-FR' : 'en-GB', { weekday: 'long', day: 'numeric', month: 'long' });
      var via = PN_FR ? ' (avec ' + zone.via + ')' : ' (with ' + zone.via + ')';
      var cc = PN_SHIP.country ? (PN_FR ? ' vers ' + PN_SHIP.country : ' to ' + PN_SHIP.country) : '';
      var sameCur = PN_SHIP.currency === zone.free[1];
      var isFree = sameCur && PN_SHIP.price >= zone.free[0];
      var html;
      if (PN_FR) {
        html = isFree
          ? '<strong>Livraison offerte</strong>' + cc + ' pour ce produit, estimée à partir du ' + dateTxt + via + '.'
          : 'Livraison estimée' + cc + ' à partir du ' + dateTxt + via + (sameCur ? '. <strong>Offerte dès ' + pnMoney(zone.free[0], zone.free[1]) + '</strong>.' : '.');
        html += ' <a class="pn-ship__more" href="' + PN_SHIP.url + '">Plus d’informations sur la livraison</a>';
      } else {
        html = isFree
          ? '<strong>Free delivery</strong>' + cc + ' for this product, estimated from ' + dateTxt + via + '.'
          : 'Estimated delivery' + cc + ' from ' + dateTxt + via + (sameCur ? '. <strong>Free over ' + pnMoney(zone.free[0], zone.free[1]) + '</strong>.' : '.');
        html += ' <a class="pn-ship__more" href="' + PN_SHIP.url + '">More information about shipping</a>';
      }
      el.innerHTML = html;
      Array.prototype.forEach.call(el.querySelectorAll('strong, a, span'), function (x) {
        x.style.setProperty('font-size', x.classList.contains('pn-ship__more') ? '12.5px' : '13.5px', 'important');
        x.style.setProperty('line-height', '1.55', 'important');
      });
    }
    var PN_SHIP_MIN = 30; /* pas d'estimation de livraison sous ce prix (petits formats : samples, travel size) */
    function pnRemoveShipping() {
      var el = section.querySelector('.pn-ship'); if (el) el.remove();
      var line = section.querySelector('.pn-ship-line'); if (line) line.remove();
    }
    function ensureShipping() {
      /* produit recommande VISIBLE ? (pilote l'affichage de la ligne au-dessus du shipping en mobile) */
      var compEl = section.querySelector('.product-info [data-block-type="complementary-products"]');
      section.classList.toggle('pn-has-comp', !!(compEl && compEl.getBoundingClientRect().height > 2));
      if (!PN_SHIP.requiresShipping || PN_SHIP.isVoucher) return; /* digital / voucher : pas d'estimation de livraison */
      if (!pnZone()) { pnRemoveShipping(); return; } /* pays non livrable depuis le store US */
      if (PN_SHIP.price < PN_SHIP_MIN) { pnRemoveShipping(); return; } /* produit trop peu cher */
      /* ancre ideale : le bloc try-it (rendu APRES ce script dans le block_order -> se repositionne aux passes suivantes) */
      var anchor = section.querySelector('.product-info__block-item.pn-tryit');
      var hasTryit = !!(anchor && anchor.querySelector('.try-it-first-text'));
      if (!hasTryit) {
        /* pas de try-it -> livraison TOUT EN BAS de la colonne, APRES les produits recommandes (le shipping doit etre le dernier element) */
        var cands = section.querySelectorAll('.product-info__block-list > .product-info__block-group, .product-info__block-list > .product-info__block-item:not(.pn-ship):not([data-block-type="liquid"])');
        var visible = Array.prototype.filter.call(cands, function (x) { return x.getBoundingClientRect().height > 2; });
        if (visible.length) anchor = visible[visible.length - 1];
      }
      if (!anchor) return;
      var el = section.querySelector('.pn-ship');
      if (!el) {
        el = document.createElement('div');
        el.className = 'pn-ship';
        /* tailles en inline important : les regles de taille du theme ecrasent les classes */
        el.style.setProperty('font-size', '13.5px', 'important');
        el.style.setProperty('line-height', '1.55', 'important');
        renderShip(el);
      }
      /* ligne de cloture (au-dessus du widget) uniquement quand il n'y a PAS de bloc try-it */
      var lineEl = section.querySelector('.pn-ship-line');
      if (!hasTryit) {
        if (!lineEl) {
          lineEl = document.createElement('hr');
          lineEl.className = 'pn-ship-line';
          lineEl.setAttribute('aria-hidden', 'true');
        }
      } else if (lineEl) { lineEl.remove(); lineEl = null; }
      /* placer la sequence [lineEl?, el] JUSTE APRES l'ancre (= dernier bloc, produits recommandes inclus) — idempotent, robuste au chargement async des recos */
      var seq = lineEl ? [lineEl, el] : [el];
      var cursor = anchor;
      seq.forEach(function (node) {
        if (cursor.nextElementSibling !== node) { cursor.parentNode.insertBefore(node, cursor.nextSibling); }
        cursor = node;
      });
      /* ligne de delimitation SOUS le widget, avant les avis (mobile uniquement) */
      var afterEl = section.querySelector('.pn-ship-after');
      if (mq.matches) {
        if (!afterEl) {
          afterEl = document.createElement('hr');
          afterEl.className = 'pn-ship-after';
          afterEl.setAttribute('aria-hidden', 'true');
        }
        if (el.nextElementSibling !== afterEl) { el.parentNode.insertBefore(afterEl, el.nextSibling); }
        hideCustomLiquidDivider(); /* diviseur decoratif d'une section soeur qui remontait dans le texte */
      } else {
        if (afterEl) afterEl.remove();
        showCustomLiquidDivider();
      }
    }
    /* sections "custom liquid" soeurs (max 3 apres le produit) ne contenant qu'un <hr> decoratif */
    function customLiquidDividers() {
      var main = document.querySelector('.shopify-section--main-product');
      if (!main) return [];
      var out = [], n = main.nextElementSibling, g = 0;
      while (n && g < 3) {
        if (n.classList && n.classList.contains('shopify-section--custom-liquid') && n.querySelectorAll('hr').length === 1) {
          var clone = n.cloneNode(true);
          Array.prototype.forEach.call(clone.querySelectorAll('style,script,hr'), function (e) { e.remove(); });
          if ((clone.textContent || '').replace(/\s/g, '') === '') out.push(n);
        }
        n = n.nextElementSibling; g++;
      }
      return out;
    }
    function hideCustomLiquidDivider() { customLiquidDividers().forEach(function (s) { s.dataset.pnHidden = '1'; s.style.display = 'none'; }); }
    function showCustomLiquidDivider() {
      document.querySelectorAll('.shopify-section--custom-liquid[data-pn-hidden]').forEach(function (s) { s.style.display = ''; s.removeAttribute('data-pn-hidden'); });
    }
    /* prix de la variante active (la gratuite depend du format choisi) */
    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant && typeof e.detail.variant.price === 'number') {
        PN_SHIP.price = e.detail.variant.price / 100;
        /* changement de format : peut passer sous/au-dessus du seuil 30 -> recree ou retire le widget */
        if (PN_SHIP.price < PN_SHIP_MIN) { pnRemoveShipping(); }
        else {
          var el = section.querySelector('.pn-ship');
          if (el) renderShip(el); else ensureShipping();
        }
      }
    });
    /* gravure cochee/decochee -> +2 jours de production dans l'estimation */
    section.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.type === 'checkbox' && t.closest('.cl-po--option[data-option="Engraving"], engraving-option, .engraving__toggle')) {
        var el = section.querySelector('.pn-ship');
        if (el) renderShip(el);
      }
    });
    /* ⚠️ localization.country (Liquid) = pays PAR DEFAUT du marche (souvent faux, ex. VE).
       On corrige avec la vraie geoloc IP de Shopify (endpoint public browsing_context_suggestions). */
    (function () {
      if (PN_SHIP.geoDone) return;
      fetch('/browsing_context_suggestions.json', { headers: { 'Accept': 'application/json' } })
        .then(function (x) { return x.json(); })
        .then(function (j) {
          var cc = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
          if (!cc && j && j.country && j.country.handle) cc = j.country.handle;
          PN_SHIP.geoDone = true;
          /* US ne livre que US+CA : pays detecte sans zone -> on montre l'estimation US par defaut */
          if (cc) {
            var pnHasZone = false;
            for (var zi = 0; zi < PN_ZONES.length; zi++) { if ((',' + PN_ZONES[zi].c + ',').indexOf(',' + cc + ',') > -1) pnHasZone = true; }
            if (!pnHasZone) cc = 'US';
          }
          if (cc && cc !== PN_SHIP.country) {
            PN_SHIP.country = cc;
            var el = section.querySelector('.pn-ship');
            if (el) renderShip(el);
          }
        })
        .catch(function () {});
    })();

    /* fleches sur le swiper d'avantages (instance Swiper.js teleportee dans le placeholder) */
    function ensureAdvArrows() {
      var sw = section.querySelector('#xm-advantages-swiper-placeholder .swiper, .swiper');
      if (!sw || !sw.swiper) return;
      var host = sw.parentElement;
      if (!host || host.querySelector('.pn-adv-arrow')) return;
      if (getComputedStyle(host).position === 'static') { host.style.position = 'relative'; }
      [
        ['prev', 'M10 2 4 8l6 6'],
        ['next', 'M6 2l6 6-6 6']
      ].forEach(function (cfg) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pn-adv-arrow pn-adv-arrow--' + cfg[0];
        b.setAttribute('aria-label', cfg[0] === 'prev' ? 'Previous' : 'Next');
        b.innerHTML = '<svg width="14" height="14" viewBox="0 0 16 16" aria-hidden="true"><path d="' + cfg[1] + '" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        b.addEventListener('click', function () {
          var el = section.querySelector('#xm-advantages-swiper-placeholder .swiper, .swiper');
          if (!el || !el.swiper) return;
          var s = el.swiper;
          var now = Date.now();
          // anti-rebond : une transition demarree il y a <350ms (clic OU autoplay) -> on ignore le clic ;
          // au-dela, le flag animating est orphelin (transitionend perdu) -> on le nettoie
          if (s.animating && now - (el.pnAdvLast || 0) < 350) return;
          s.animating = false;
          el.pnAdvLast = now;
          cfg[0] === 'prev' ? s.slidePrev(300) : s.slideNext(300);
          if (s.autoplay && s.autoplay.stop) {
            s.autoplay.stop();
            clearTimeout(el.pnAdvT);
            el.pnAdvT = setTimeout(function () { if (s.autoplay && s.autoplay.start) s.autoplay.start(); }, 9000);
          }
        });
        host.appendChild(b);
      });
      // horodater CHAQUE debut de transition (clic ou autoplay) pour l'anti-rebond
      if (sw.swiper.on && !sw.pnAdvHook) {
        sw.pnAdvHook = true;
        sw.swiper.on('slideChangeTransitionStart', function () { sw.pnAdvLast = Date.now(); });
      }
    }

    /* skin Cloudlift : libelle actif, placeholder, compteur, montant sans .00, alerte + info-bulle façon natif */
    var PN_FR = CFG.fr;
    var PN_TXT = {
      active: PN_FR ? 'Un flacon comme aucun autre' : 'A bottle like no other',
      forbidden: PN_FR ? 'Caractère non autorisé' : 'Character not allowed',
      tooltip: PN_FR ? '<p>Ajoutez un prénom, une date ou quelques mots. Lettres uniquement, dans la limite indiquée.</p>' : '<p>Add a name, a date or a few words. Letters only, up to the maximum shown.</p>',
      learn: PN_FR ? 'En savoir plus' : 'Learn more',
      placeholder: PN_FR ? 'Texte à graver' : 'Text to engrave'
    };
    var PN_CLEAN = /[^A-Za-zÀ-ÿ0-9 .\-+]/g;

    function skinCloudlift() {
      var engLbl = section.querySelector('.cl-po--option[data-option="Engraving"] .cl-po--checkbox-item');
      if (engLbl && !engLbl.querySelector('.pn-lbl-on')) {
        var off = document.createElement('span');
        off.className = 'pn-lbl-off';
        Array.prototype.slice.call(engLbl.childNodes).forEach(function (n) {
          if (n.nodeType === 1 && n.tagName === 'INPUT') return;
          off.appendChild(n);
        });
        engLbl.appendChild(off);
        var on = document.createElement('span');
        on.className = 'pn-lbl-on';
        on.textContent = PN_TXT.active;
        engLbl.appendChild(on);
      }
      if (engLbl) {
        // montant sans decimales inutiles (10.00 / 10,00 -> 10) et pas d'espace entre + et le montant
        var mEl = engLbl.querySelector('.money');
        if (mEl && /[.,]00(?!\d)/.test(mEl.textContent)) {
          mEl.textContent = mEl.textContent.replace(/[.,]00(?!\d)/, '');
        }
        var offSpan = engLbl.querySelector('.pn-lbl-off');
        if (offSpan) {
          Array.prototype.forEach.call(offSpan.childNodes, function (n) {
            if (n.nodeType === 3 && /\(\+\s+$/.test(n.textContent)) {
              n.textContent = n.textContent.replace(/\(\+\s+$/, '(+');
            }
          });
        }
      }
      var opt = section.querySelector('.cl-po--option[data-option="Wording"]');
      if (!opt) return;
      var inp = opt.querySelector('input.cl-po--input[type="text"]');
      if (!inp) return;
      if (!inp.getAttribute('placeholder')) {
        var lbl = opt.querySelector('.cl-po--label');
        var ph = lbl ? lbl.textContent.trim() : '';
        inp.setAttribute('placeholder', ph || PN_TXT.placeholder);
      }
      /* alerte discrete (remplace la banniere rouge "engrave_validation") */
      var alertEl = opt.querySelector('.pn-eng-alert');
      if (!alertEl) {
        alertEl = document.createElement('span');
        alertEl.className = 'pn-eng-alert';
        alertEl.setAttribute('role', 'alert');
        var helpRef = opt.querySelector('.cl-po--help');
        if (helpRef) { opt.insertBefore(alertEl, helpRef); } else { opt.appendChild(alertEl); }
      }
      /* info-bulle (i) dans le champ, remplace la ligne "Learn more about the engraving" */
      if (!opt.querySelector('.pn-eng-info')) {
        var infoLink = document.querySelector('.cl-po--option[data-option="info"] a');
        var href = infoLink ? infoLink.getAttribute('href') : '/products/engraving-service';
        var info = document.createElement('span');
        info.className = 'pn-eng-info';
        info.setAttribute('tabindex', '0');
        info.setAttribute('role', 'note');
        info.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9.25" stroke="currentColor" stroke-width="1.5"/><path d="M12 10.6v6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><circle cx="12" cy="7.6" r="1.05" fill="currentColor"/></svg>'
          + '<span class="pn-eng-tooltip">' + PN_TXT.tooltip + '<a class="pn-eng-tooltip-link" href="' + href + '">' + PN_TXT.learn + '</a></span>';
        opt.appendChild(info);
        info.style.top = (inp.offsetTop + inp.offsetHeight / 2 - 9) + 'px';
      }
      if (!inp.pnCount) {
        inp.pnCount = true;
        var help = opt.querySelector('.cl-po--help');
        var base = help ? help.textContent.trim() : '';
        inp.addEventListener('input', function () {
          /* nettoyage des caracteres interdits a la saisie (comme le bloc natif) */
          var v = inp.value;
          var cleaned = v.replace(PN_CLEAN, '');
          if (cleaned !== v) {
            var pos = (inp.selectionStart || cleaned.length) - (v.length - cleaned.length);
            inp.value = cleaned;
            try { inp.setSelectionRange(pos, pos); } catch (e) {}
            alertEl.textContent = PN_TXT.forbidden;
            alertEl.classList.add('is-shown');
            clearTimeout(inp.pnAlertT);
            inp.pnAlertT = setTimeout(function () { alertEl.classList.remove('is-shown'); }, 2000);
          }
          if (!help) return;
          var max = parseInt(inp.getAttribute('maxlength') || '22', 10);
          var n = inp.value.length;
          if (!n) { help.textContent = base; help.classList.remove('pn-max'); }
          else { help.textContent = n + ' / ' + max; help.classList.toggle('pn-max', n >= max); }
        });
      }
    }

    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      setTimeout(function () { scheduled = false; apply(); }, 60);
    }

    apply();
    [1500, 3500, 6000].forEach(function (t) { setTimeout(function () { applyTitleSizes(mq.matches); ensureAdvArrows(); ensureContentLast(); ensureShipping(); }, t); });
    if (mq.addEventListener) { mq.addEventListener('change', schedule); }
    else if (mq.addListener) { mq.addListener(schedule); }
    window.addEventListener('resize', schedule);
    new MutationObserver(schedule).observe(section, { childList: true, subtree: true });
  
  }
  window.pnInit = function () { document.querySelectorAll('script[data-pn-cfg]').forEach(initOne); };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', window.pnInit); } else { window.pnInit(); }
})();
